import React from "react";
import { BsPatchCheckFill } from "react-icons/bs";
import ReactStars from "react-stars";
import "./experience.css";

const Experience = () => {
  return (
    <section id="experience">
      <h5>What Skills I Have</h5>
      <h2>My Experience</h2>

      <div className="container experience__container">
        <div
          className="experience__frontend"
          data-aos="flip-left"
          data-aos-duration="1000"
        >
          <h3>Frontend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>HTML</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>CSS</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>BootStrap</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>JavaScript</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>React Js</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>NextJs</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>React Bootstrap</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Redux</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={3.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Axios</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={3.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>jQuery</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Vue Js</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={3}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Material Ui</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={2.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
          </div>
        </div>
        <div
          className="experience__tools"
          data-aos="flip-left"
          data-aos-duration="1000"
          data-aos-delay="150"
        >
          <h3>Development Tools</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Git</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Postman</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Swagger</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>NPM</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Yarn</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
          </div>
        </div>
        <div
          className="experience__backend"
          data-aos="flip-left"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <h3>Backend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>PHP</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Codeigniter</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={4.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>Laravel</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={2.5}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>NodeJs</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={2}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon" />
              <div>
                <h4>MySQL</h4>
                <ReactStars
                  count={5}
                  edit={false}
                  size={20}
                  value={3}
                  color1={"#fff"}
                  color2={"var(--color-primary)"}
                />
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
